import { createContext } from "react";

const MapIsTypingContext = createContext(false);

export default MapIsTypingContext